<div class="alert alert-secondary" role="alert">
    <p class="mb-0"><b>Note</b> During the registration process, Twilio may reach out to the authorized representative to confirm your business identity. You can view <a href="https://www.twilio.com/en-us/legal/privacy" target="_blank">Twilio's Privacy Statement</a> to learn more about how they retain these records.</p>
</div>
<form [formGroup]="contactPersonForm">
    <div class="form-group mb-3">
        <label class="form-label">Business Title</label>
        <input type="text" class="form-control" formControlName="businessTitle" placeholder="President" [class.is-invalid]="businessTitle.invalid && (businessTitle.dirty || businessTitle.touched)" required>
        @if (businessTitle.invalid && (businessTitle.dirty || businessTitle.touched)) {
        @if (businessTitle.errors?.['required']) { <div class="input-validation-msg">Business Title is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="my-auto">Email</label>
        <input type="text" class="form-control" formControlName="email" placeholder="jappleseed@example.com" [class.is-invalid]="email.invalid && (email.dirty || email.touched)" required>
        @if (email.invalid && (email.dirty || email.touched)) {
        @if (email.errors?.['required']) { <div class="input-validation-msg">Email is required.</div> }
        @if (email.errors?.['email']) { <div class="input-validation-msg">Email is invalid.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">First Name</label>
        <input type="text" class="form-control" formControlName="firstName" placeholder="John" [class.is-invalid]="firstName.invalid && (firstName.dirty || firstName.touched)" required>
        @if (firstName.invalid && (firstName.dirty || firstName.touched)) {
        @if (firstName.errors?.['required']) { <div class="input-validation-msg">First Name is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Last Name</label>
        <input type="text" class="form-control" formControlName="lastName" placeholder="Appleseed" [class.is-invalid]="lastName.invalid && (lastName.dirty || lastName.touched)" required>
        @if (lastName.invalid && (lastName.dirty || lastName.touched)) {
        @if (lastName.errors?.['required']) { <div class="input-validation-msg">Last Name is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Job Position</label>
        <select class="form-select" formControlName="jobPosition" [class.is-invalid]="jobPosition.invalid && (jobPosition.dirty || jobPosition.touched)" required>
            <option selected disabled [value]="null">Select a Position</option>
            @for (jobPosition of jobPositionValues; track jobPosition.value) {
            <option [value]="jobPosition.value">{{jobPosition.name}}</option>
            }
        </select>
        @if (jobPosition.invalid && (jobPosition.dirty || jobPosition.touched)) {
        @if (jobPosition.errors?.['required']) { <div class="input-validation-msg">Job Position is required.</div> }
        }
    </div>
    <div class="form-group mb-3">
        <label class="form-label">Phone Number</label>
        <div class="input-group">
            <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn btn-outline-secondary" ngbDropdownToggle style="border-top-right-radius: 0; border-bottom-right-radius: 0;">{{selectedCountryCode}}</button>
                <div ngbDropdownMenu>
                    @for (countryCode of countryCodes; track countryCode.value) {
                    <button type="button" ngbDropdownItem (click)="selectCountryCode(countryCode.value);">{{countryCode.label}}</button>
                    }
                </div>
            </div>
            <input type="text" class="form-control" formControlName="phoneNumber" placeholder="1234567890" [class.is-invalid]="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)" required>
        </div>
        @if (phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)) {
        @if (phoneNumber.errors?.['required']) { <div class="input-validation-msg">Phone Number is required.</div> }
        }
    </div>
</form>
<button type="button" class="btn btn-primary w-100" (click)="submitForm();" [disabled]="!contactPersonForm.valid">Next</button>